import { useMutation } from '@apollo/client';
import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { DELETE_HOST, IDeleteHostResponse } from 'schemas';
import notification from 'services/notificationService';

import { TDeleteHost } from './interfaces';

export const useDeleteHost = (t: TTranslator<TLocalesKeys>): TDeleteHost => {
  const [deleteHost] = useMutation<IDeleteHostResponse>(DELETE_HOST, {
    update: (cache, { data }) => {
      const host = data?.deleteHost;

      if (!host) return;

      cache.evict({
        id: cache.identify({ ...host, __typename: 'HostOverview' }),
      });
      cache.gc();
    },
    onCompleted: ({ deleteHost: { alias, in_service } }) => {
      if (in_service) {
        notification.info({
          t,
          leftDescription: alias,
          title: t('host.delete.error.title'),
          message: t('host.delete.error.message'),
          type: 'error',
          dismiss: 5,
        });
        return;
      }
      notification.info({
        t,
        leftDescription: alias,
        title: t('host.delete.success'),
        type: 'success',
        dismiss: 5,
      });
    },
  });

  return deleteHost;
};
